import React, { Component } from "react";
import { FormControl, Button, FormGroup, Row, ControlLabel, Col, Table, Form } from "react-bootstrap";
import { PropTypes } from "prop-types";
import { LoadingSpinner } from "../LoadingSpinner";
import { BusMapAPI } from "../../api/busmap/BusMapAPI";
import { TitleRow } from "../../components/TitleRow";
import { HandleDialog } from "../../components/HandleDialog";
import { HandleMessage } from "../../components/HandleMessage";
import Select from "react-select";
import { strings } from "./strings";
import "array-flat-polyfill";
import { SortIndicator } from '../SortIndicator';

const initialStep = "stops";

export class NewBusMap extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    };

    constructor(props) {
        super(props);

        this.state = {
            loadingNetwork: false,
            loading: true,
            showExecutingModal: false,
            lines: undefined,
            stops: undefined,
            lineFilter: undefined,
            stopNameFilter: undefined,
            previousLineFilter: undefined,
            previousStopNameFilter: undefined,
            linesById: undefined,
            stopsById: undefined,
            mapPointsById: undefined,
            headers: undefined,
            footers: undefined,
            lineStops: [],
            selectedStops: [],
            selectedRoutes: [],
            selectedMapPoints: [],
            availableRoutes: [],
            generatedFiles: [],
            visibleStops: [],
            currentStep: initialStep,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            },
            errorModal: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                extraButton: undefined
            },
            selectedImages: {
                header: undefined,
                footer: undefined
            },
            sortOrder: "ascending",
            sortColumn: "code"
        };
    }

    componentDidMount() {
        this.context.selectApp("busmap", false);
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        this.setState({
            loadingEdition: true
        });
    }

    endUpdate() {
        this.setState({
            loadingEdition: false
        });
    }

    updateNetwork() {
        this.setState({
            loading: true
        }, () => {
            this.getData(this.context.edition);
        });
    }

    // ----------------------

    isTransportAuthorityData() {
        const { selectedProvider } = this.context;

        return undefined !== selectedProvider && selectedProvider.startsWith("0:");
    }

    removeDuplicates(myArr, prop) {
        return myArr.filter((obj, pos, arr) => {
            return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
        });
    }

    setErrorMessage(error) {
        this.setState({
            errorModal: {
                show: true,
                title: strings.error,
                message: error.message,
                style: 'danger',
                icon: 'remove'
            }
        });
    }

    processLinesData(data) {
        var paths = this.removeDuplicates(
            data.map(line => line.paths).flat(),
            "id"
        );
        var mapPoints = this.removeDuplicates(
            data.map(line => line.mapPoints).flat(),
            "id"
        );

        var linesById = {},
            mapPointsById = {};

        data.forEach((value) => {
            linesById[value.id] = value;
        });

        mapPoints.forEach((value) => {
            mapPointsById[value.id] = value;
        });

        this.setState({
            loading: false,
            lines: data,
            linesById: linesById,
            paths: paths,
            mapPoints: mapPoints,
            mapPointsById: mapPointsById
        });
    }

    processStopsData(data) {
        var stopsById = {};

        data.forEach((value) => {
            stopsById[value.id] = value;
        });

        this.setState({
            stops: data,
            stopsById: stopsById,
            visibleStops: data
        });
    }

    getData(edition) {
        if (this.isTransportAuthorityData()) {
            BusMapAPI.getAllTransportAuthorityLines()
                .then(response => JSON.parse(response))
                .then(data => this.processLinesData(data))
                .catch(error => this.setErrorMessage(error));

            BusMapAPI.getAllTransportAuthorityStops()
                .then(response => JSON.parse(response))
                .then(data => this.processStopsData(data))
                .catch(error => this.setErrorMessage(error));
        }
        else {
            let selectedProviderId = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProviderId = this.context.selectedProvider.split(':')[0];
            }

            BusMapAPI.getAllLines(edition.network, selectedProviderId)
                .then(response => JSON.parse(response))
                .then(data => this.processLinesData(data))
                .catch(error => this.setErrorMessage(error));

            BusMapAPI.getAllStops(edition.network, selectedProviderId)
                .then(response => JSON.parse(response))
                .then(data => this.processStopsData(data))
                .catch(error => this.setErrorMessage(error));
        }
    }

    filterByMapPoints(mapPointsForStop, stop, selectedMapPoints) {
        return mapPointsForStop
            .filter(mapPoint => mapPoint !== stop.mapPointId)
            .filter(mapPoint => selectedMapPoints.map(mp => mp.id).includes(mapPoint));
    }

    processGenerationData(data) {
        var dialogOptions = {};

        if (data.length === 0) {
            dialogOptions = {
                show: true,
                title: strings.error,
                message: strings.noBusMapsGenerated,
                style: "danger",
                icon: "remove"
            };
        } else {
            dialogOptions = {
                show: true,
                title: strings.success,
                message: strings.formatString(
                    strings.generationSuccessful,
                    data.length
                ),
                style: 'success',
                icon: 'ok'
            };
        }

        this.setState({
            generatedFiles: data,
            loading: false,
            showExecutingModal: false,
            errorModal: dialogOptions
        });
    }

    generate() {
        var { selectedStops, selectedRoutes, selectedMapPoints, stopsById, mapPointsById } = this.state;
        const { edition } = this.context;

        var busMapStops = [];

        for (var i = 0; i < selectedStops.length; i++) {
            var stop = selectedStops[i];
            var routes = selectedRoutes[i];

            var mapPointsForStop = [];

            // Os MapPoints têm de ser filtrados: não enviar MapPoints que não pertecem às Rotas selecionadas
            for (var j = 0; j < routes.length; j++) {
                var route = routes[j];

                var currentStopIndex = route.stopIds.indexOf(stop.id);
                var stopsAfterSelected = route.stopIds
                    .slice(currentStopIndex + 1)
                    .map(stopId => stopsById[stopId])
                    .filter(stop => stop.mapPointId > 0);
                // Ir buscar um array com todos os map points de todas as paragens à seguir à actual
                var mapPointsAfterSelected = stopsAfterSelected.map(
                    stop => mapPointsById[stop.mapPointId]
                );
                mapPointsForStop.push(mapPointsAfterSelected);
            }

            mapPointsForStop = [...new Set(mapPointsForStop.flat().map(e => e.id))];
            mapPointsForStop = this.filterByMapPoints(mapPointsForStop, stop, selectedMapPoints);

            var temp = {
                StopId: selectedStops[i].id,
                RoutesId: selectedRoutes[i].map(e => e.id),
                MapPointsIds: mapPointsForStop
            };
            busMapStops.push(temp);
        }


        if (this.isTransportAuthorityData()) {
            BusMapAPI.generateTransportAuthority(busMapStops)
                .then(response => JSON.parse(response))
                .then(data => this.processGenerationData(data))
                .catch(error => this.setErrorMessage(error));
        }
        else {
            let selectedProviderId = '';
            if (this.context.selectedProvider !== undefined) {
                selectedProviderId = this.context.selectedProvider.split(':')[0];
            }

            BusMapAPI.generate(edition.network, busMapStops, selectedProviderId)
                .then(response => JSON.parse(response))
                .then(data => this.processGenerationData(data))
                .catch(error => this.setErrorMessage(error));
        }
    }

    filterByLine = event => {
        var { visibleStops, stops, previousLineFilter, lineFilter } = this.state;

        previousLineFilter = lineFilter;

        if (event === null) {
            this.setState({
                visibleStops: stops,
                lineFilter: undefined,
                previousLineFilter
            });
            return;
        }

        var stopIds = [];
        event.paths.forEach(function (path) {
            stopIds.push(path.stopIds);
        });
        stopIds = [...new Set(stopIds.flat())];

        visibleStops = stops.filter(function (stop) {
            return stopIds.includes(stop.id);
        });

        this.setState({
            lineFilter: event,
            previousLineFilter,
            visibleStops: visibleStops
        });
    };

    filterByStopName = event => {
        var { visibleStops, stops, stopNameFilter, previousStopNameFilter } = this.state;

        previousStopNameFilter = stopNameFilter;

        if (event === null) {
            this.setState({
                visibleStops: stops,
                previousStopNameFilter
            });
            return;
        }

        visibleStops = stops.filter(function (stop) {
            return (
                (undefined !== stop.code && stop.code.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1)
                || (undefined !== stop.name && stop.name.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1)
                || (undefined !== stop.shortName && stop.shortName.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1)
                || (undefined !== stop.extCode && stop.extCode.toLowerCase().indexOf(event.target.value.toLowerCase()) !== -1)
            );
        });

        this.setState({
            lineFilter: event,
            previousStopNameFilter,
            visibleStops: visibleStops
        });
    };

    // #region Funções de seleção

    toggleStopSelection = stop => {
        var { selectedStops } = this.state;

        // Se a paragem já estiver selecionada, remove
        if (selectedStops.filter(e => e.id === stop.id).length > 0) {
            var index = selectedStops.map(e => e.id).indexOf(stop.id);
            if (index > -1) {
                selectedStops.splice(index, 1);
            }
        }
        // caso contrário adiciona
        else {
            selectedStops.push(stop);
        }

        this.setState({ selectedStops });
    };

    toggleRouteSelectionForStop = (route, stopIndex) => {
        var { selectedRoutes } = this.state;

        // Se a paragem já estiver selecionada, remove
        if (selectedRoutes[stopIndex].filter(e => e.id === route.id).length > 0) {
            var index = selectedRoutes[stopIndex].map(e => e.id).indexOf(route.id);
            if (index > -1) {
                selectedRoutes[stopIndex].splice(index, 1);
            }
        }
        // caso contrário adiciona
        else {
            selectedRoutes[stopIndex].push(route);
        }

        this.setState({ selectedRoutes });
    };

    toggleMapPointSelection = mapPoint => {
        var { selectedMapPoints } = this.state;

        if (selectedMapPoints.filter(e => e.id === mapPoint.id).length > 0) {
            var index = selectedMapPoints.map(e => e.id).indexOf(mapPoint.id);
            if (index > -1) {
                selectedMapPoints.splice(index, 1);
            }
        }
        // caso contrário adiciona
        else {
            selectedMapPoints.push(mapPoint);
        }

        this.setState({ selectedMapPoints });
    };

    selectAllRoutesForStop = stopIndex => {
        var { selectedRoutes, availableRoutes } = this.state;

        if (selectedRoutes[stopIndex].length !== availableRoutes[stopIndex].length) {

            selectedRoutes[stopIndex] = [];
            for (var index in availableRoutes[stopIndex]) {
                var route = availableRoutes[stopIndex][index];

                selectedRoutes[stopIndex].push(route);
            }
        } else {

            selectedRoutes[stopIndex] = [];
        }

        this.setState({ selectedRoutes });
    };

    selectAllRoutesForAllStops = () => {
        var { selectedStops } = this.state;

        for (var i = 0; i < selectedStops.length; i++) {
            this.selectAllRoutesForStop(i);
        }
    };

    invertSelectedRoutesForStop = stopIndex => {
        var { selectedRoutes, availableRoutes } = this.state;
        var temp = [];
        var routeIds = selectedRoutes[stopIndex].map((route, index) => {
            return route.id;
        });

        for (var index in availableRoutes[stopIndex]) {
            var route = availableRoutes[stopIndex][index];

            // se não estava originalmente selecionada, seleciona
            if (!routeIds.includes(route.id)) {
                temp.push(route);
            }
        }

        selectedRoutes[stopIndex] = temp;

        this.setState({ selectedRoutes });
    };

    selectAllMapPoints = () => {
        var { selectedMapPoints, availableMapPoints } = this.state;

        let newSelection = selectedMapPoints.length === availableMapPoints.length ? [] : availableMapPoints.map(e => e);

        this.setState({ selectedMapPoints: newSelection });
    };

    selectAllStops = () => {
        var { stops, selectedStops } = this.state;

        let newSelection = selectedStops.length === stops.length ? [] : stops.map(e => e);

        this.setState({
            selectedStops: newSelection
        });
    }

    selectAllVisibleStops = () => {
        var { selectedStops, visibleStops, lineFilter, stopNameFilter, previousLineFilter, previousStopNameFilter } = this.state;

        if (undefined === lineFilter) {
            this.selectAllStops();
        } else {
            if (previousLineFilter !== lineFilter || previousStopNameFilter !== stopNameFilter) {
                visibleStops.map(s => -1 === selectedStops.findIndex(s1 => s1.code === s.code) ? selectedStops.push(s) : null);
            } else {
                visibleStops.forEach(s => {
                    let index = selectedStops.findIndex(s1 => s1.code === s.code);
                    -1 === index ? selectedStops.push(s) : selectedStops.splice(index, 1);
                });
            }

            this.setState({
                selectedStops,
                previousLineFilter: lineFilter,
                previousStopNameFilter: stopNameFilter
            });
        }
    }

    // #region Funções de seleção

    /* #region Passos do wizard */

    selectStops = () => {
        this.setState({
            currentStep: "stops"
        });
    };

    filterPathsByStops(paths, stop) {
        return paths.filter(value => value.stopIds.indexOf(stop.id) >= 0);
    }

    validateStops = () => {
        var { selectedStops, selectedRoutes, paths } = this.state;

        var confirmed = true,
            availableRoutes = [],
            stopsWithNoRoutes = [];

        for (var i = 0; i < selectedStops.length; i++) {
            var stop = selectedStops[i];

            selectedRoutes[i] =
                selectedRoutes[i] === undefined ? [] : selectedRoutes[i];

            availableRoutes[i] = this.filterPathsByStops(paths, stop);

            if (availableRoutes[i].length === 0) {
                stopsWithNoRoutes.push(selectedStops[i].name);
                confirmed = false;
            }
        }

        if (confirmed) {
            this.setState(
                {
                    selectedRoutes: selectedRoutes,
                    availableRoutes: availableRoutes
                },
                this.selectRoutes
            );
            return;
        }

        this.setState({
            errorModal: {
                show: true,
                title: strings.warning,
                message: [
                    strings.stopsWithNoRoutes,
                    React.createElement(
                        "ul",
                        { key: "ul-warning" },
                        stopsWithNoRoutes.map((value, index) => (
                            <li key={index}>{value}</li>
                        ))
                    )
                ],
                style: "warning",
                icon: "alert"
            }
        });
    };

    selectRoutes = () => {
        this.setState({
            currentStep: "routes",
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    };

    validateRoutes = () => {
        var { selectedStops, selectedRoutes, stopsById } = this.state;

        var confirmed = true,
            stopsWithError = [];

        // Valida se as paragens término de algum dos percursos selecionados não estão associadas a pontos notáveis
        for (let i in selectedRoutes) {
            var routesToCheck = [...new Set(selectedRoutes[i].flat())];
            for (var k in routesToCheck) {
                var routeToCheck = routesToCheck[k];
                var startStopId = routeToCheck.stopIds[0];
                var endStopId = routeToCheck.stopIds[routeToCheck.stopIds.length - 1];

                var startStop = stopsById[startStopId];
                var endStop = stopsById[endStopId];

                if (startStop.mapPointId === 0 || endStop.mapPointId === 0) {
                    stopsWithError.push(
                        this.getNameForOrientation(
                            routeToCheck.lineId,
                            routeToCheck.orientation
                        )
                    );
                    confirmed = false;
                }
            }
        }

        if (!confirmed) {
            this.setState({
                dialog: {
                    show: true,
                    title: strings.warning,
                    message: [
                        strings.terminalStopsWithoutMapPoints,
                        React.createElement(
                            "ul",
                            { key: "ul-warning" },
                            stopsWithError.map((value, index) => <li key={index}>{value}</li>)
                        ),
                        strings.areYouSure
                    ],
                    style: "warning",
                    icon: "alert",
                    argument: {
                        next: this.selectMapPoints
                    }
                }
            });
            return;
        }

        // Alerta para quando se escolhem mais de 6 percursos por paragem
        confirmed = true;
        stopsWithError = [];

        for (let i in selectedRoutes) {
            if (selectedRoutes[i].length > 6) {
                stopsWithError.push(selectedStops[i].name);
                confirmed = false;
            }
        }

        if (!confirmed) {
            this.setState({
                dialog: {
                    show: true,
                    title: strings.warning,
                    message: [
                        strings.moreThanSix,
                        React.createElement(
                            "ul",
                            {},
                            stopsWithError.map((value, index) => <li key={index}>{value}</li>)
                        ),
                        strings.moreThanSixPost,
                        strings.areYouSure
                    ],
                    style: "warning",
                    icon: "alert",
                    argument: {
                        next: this.selectMapPoints
                    }
                }
            });
            return;
        }

        if (confirmed) {
            this.selectMapPoints();
        }
        return;
    };

    selectMapPoints = () => {
        var {
            selectedStops,
            selectedRoutes,
            mapPointsById,
            stopsById
        } = this.state;

        var availableMapPoints = [];

        //carregar os map points de todas as paragens de todos os percursos selecionados
        for (var i = 0; i < selectedStops.length; i++) {
            var stop = selectedStops[i];
            var routes = selectedRoutes[i];

            // Em cada route
            for (var j = 0; j < routes.length; j++) {
                var route = routes[j];

                var currentStopIndex = route.stopIds.indexOf(stop.id);
                var stopsAfterSelected = route.stopIds
                    .slice(currentStopIndex + 1)
                    .map(stopId => stopsById[stopId])
                    .filter(stop => stop.mapPointId > 0);
                // Ir buscar um array com todos os map points de todas as paragens à seguir à actual
                var mapPointsAfterSelected = stopsAfterSelected.map(
                    stop => mapPointsById[stop.mapPointId]
                );
                availableMapPoints.push(mapPointsAfterSelected);
            }
        }

        this.setState({
            availableMapPoints: this.removeDuplicates(
                availableMapPoints.flat(),
                "id"
            ),
            currentStep: "mapPoints",
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    };

    validateMapPoints = () => {
        var {
            selectedMapPoints,
            selectedStops,
            selectedRoutes,
            // mapPoints,
            mapPointsById,
            stopsById
        } = this.state;

        var confirmed = true,
            routesWithError = [];

        // Verificar referências circulares (isto significa que entre a paragem e o fim do percurso um map point aparece duas vezes)

        // Para cada paragem
        for (var i = 0; i < selectedStops.length; i++) {
            var stop = selectedStops[i];
            var routes = selectedRoutes[i];

            // Em cada route
            for (var j = 0; j < routes.length; j++) {
                var route = routes[j];
                // Encontrar todas as paragens a seguir à paragem actual
                var currentStopIndex = route.stopIds.indexOf(stop.id);
                var stopsAfterSelected = route.stopIds
                    .slice(currentStopIndex + 1)
                    .map(stopId => stopsById[stopId])
                    .filter(stop => stop.mapPointId > 0);
                // Ir buscar um array com todos os map points de todas as paragens à seguir à actual
                var mapPointsAfterSelected = stopsAfterSelected.map(
                    stop => mapPointsById[stop.mapPointId]
                );
                // Remover map points não selecionados
                mapPointsAfterSelected = mapPointsAfterSelected.filter(mapPoint =>
                    selectedMapPoints.map(mp => mp.id).includes(mapPoint.id)
                );

                // Verificar se há map points duplicados
                // FIXME falta verificar correctamente as dependências circulares
                confirmed = true;
                /*var hasDuplicates = mapPointsAfterSelected.reduce(function(acc, el, i, arr) {
                            if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
                          }, []);
        
                        if(hasDuplicates.length > 0) {
                            routesWithError.push(this.getNameForOrientation(route.lineId, route.orientation));
                            confirmed = false;
                        }*/
            }
        }

        if (!confirmed) {
            this.setState({
                dialog: {
                    show: true,
                    title: strings.warning,
                    message: [
                        strings.circularDependenciesDetected,
                        React.createElement(
                            "ul",
                            {},
                            routesWithError.map((value, index) => (
                                <li key={index}>{value}</li>
                            ))
                        ),
                        strings.areYouSure
                    ],
                    style: "warning",
                    icon: "alert",
                    argument: {
                        next: this.showSummary
                    }
                }
            });
            return;
        }

        if (confirmed) {
            this.showSummary();
        }
        return;
    };

    showSummary = () => {
        this.setState({
            currentStep: "summary",
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    };

    generateBusMaps = () => {
        this.setState(
            {
                showExecutingModal: true
            },
            () => this.generate()
        );
    };

    onExit = (a, b) => {
        if (a) {
            if(undefined !== b) { b.next(); }
            return;
        }

        this.setState({
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    };

    clearError = () => {
        this.setState({
            showExecutingModal: false,
            errorModal: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    };

    /* #endregion Passos do wizard */

    stopSelectionFilters = () => {
        var { lines } = this.state;

        return (
            <Row>
                <Form horizontal>
                    <Col sm={12}>
                        {typeof lines !== "undefined" && lines.length !== 0 ? (
                            <FormGroup controlId="formBasicText" style={{ padding: 10 }}>
                                <Col sm={12} md={2}>
                                    <ControlLabel>{strings.filterByLine}</ControlLabel>
                                </Col>
                                <Col sm={12} md={10}>
                                    <Select
                                        onChange={this.filterByLine}
                                        getOptionLabel={a => a.goName}
                                        getOptionValue={a => a.id}
                                        options={lines}
                                        value={this.state.lineFilter}
                                        isClearable={true}
                                        isSearchable={true}
                                    />
                                </Col>
                            </FormGroup>
                        ) : null}
                        <FormGroup controlId="formBasicText" style={{ padding: 10 }}>
                            <Col sm={12} md={2}>
                                <ControlLabel>{strings.filterByStopName}</ControlLabel>
                            </Col>
                            <Col sm={12} md={10}>
                                <FormControl
                                    type="text"
                                    value={this.state.stopNameFilter}
                                    placeholder={strings.insertStopName}
                                    onChange={this.filterByStopName}
                                />
                            </Col>
                        </FormGroup>
                    </Col>
                </Form>
            </Row>
        );
    };

    listSelectedStops = () => {
        var { selectedStops } = this.state;

        return (
            <Col sm={12} md={4}>
                <TitleRow
                    title={strings.selectedStops}
                    showSeparator={false}
                    showBackground={false}
                    element="h2"
                />
                {typeof selectedStops !== "undefined" && selectedStops.length !== 0 ? (
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>{strings.code}</th>
                                <th>{strings.name}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {selectedStops
                                .sort((a, b) => a.code.localeCompare(b.code))
                                .map((stop, Index) => (
                                    <tr
                                        key={Index}
                                        onClick={() => this.toggleStopSelection(stop)}
                                        className="bus-map-stop-selected"
                                    >
                                        <td>{stop.code}</td>
                                        <td>{stop.name}</td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                ) : null}
            </Col>
        );
    };

    selectStopsTable = () => {
        var { selectedStops, visibleStops, sortColumn, sortOrder } = this.state;

        return (
            <Col sm={12} md={8}>
                <TitleRow
                    title={strings.allStops}
                    showSeparator={false}
                    showBackground={false}
                    element="h2"
                />
                {typeof visibleStops !== "undefined" && visibleStops.length !== 0 ? (
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th onClick={() => this.changeSort('code')}>{strings.code} {sortColumn === "code" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                                <th onClick={() => this.changeSort('name')}>{strings.name} {sortColumn === "name" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                                <th onClick={() => this.changeSort('shortName')}>{strings.shortName} {sortColumn === "shortName" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                                <th onClick={() => this.changeSort('extCode')}>{strings.extCode} {sortColumn === "extCode" ? <SortIndicator order={sortOrder} /> : <SortIndicator order="none" />}</th>
                                <th><Button bsStyle="link" onClick={() => this.selectAllVisibleStops()}> {strings.selectAllVisibleStops} </Button> </th>
                            </tr>
                        </thead>
                        <tbody>
                            {visibleStops
                                .sort(this.sort)
                                .map((stop, Index) => (
                                    <tr
                                        key={Index}
                                        onClick={() => this.toggleStopSelection(stop)}
                                        className={
                                            selectedStops.filter(e => e.id === stop.id).length > 0
                                                ? "bus-map-stop-selected"
                                                : null
                                        }
                                    >
                                        <td>{stop.code}</td>
                                        <td>{stop.name}</td>
                                        <td>{stop.shortName}</td>
                                        <td>{stop.extCode}</td>
                                        <td></td>
                                    </tr>
                                ))}
                        </tbody>
                    </Table>
                ) : (
                        <p className="empty-set">{strings.noExistingStops}</p>
                    )}
            </Col>
        );
    };

    getNameForOrientation(lineId, orientation) {
        var { linesById } = this.state;

        var element = linesById[lineId];

        return orientation === "G" ? element.goName : element.returnName;
    }

    getLineParameter(lineId, parameter) {
        var { linesById } = this.state;

        var element = linesById[lineId];

        return element[parameter];
    }

    selectRoutesTable() {
        var {
            availableRoutes,
            selectedRoutes,
            selectedStops,
            stopsById
        } = this.state;

        return (
            <div>
                {typeof availableRoutes !== "undefined" && availableRoutes.length !== 0
                    ? selectedStops.map((stop, stopIndex) => (
                        <Row key={stopIndex}>
                            <Col sm={12}>
                                <TitleRow
                                    title={`${stop.code} - ${stop.name}`}
                                    showSeparator={false}
                                    showBackground={true}
                                    element="h2"
                                />
                                <Table responsive striped hover>
                                    <thead>
                                        <tr>
                                            <th>{strings.lineCode}</th>
                                            <th>{strings.lineDescription}</th>
                                            <th>{strings.code}</th>
                                            <th>{strings.orientation}</th>
                                            <th>{strings.origin}</th>
                                            <th>{strings.destination}</th>
                                            <th className="text-center">
                                                <Button
                                                    bsStyle="link"
                                                    onClick={() =>
                                                        this.selectAllRoutesForStop(stopIndex)
                                                    }
                                                >
                                                    {strings.selectAll}
                                                </Button>
                                                <Button
                                                    bsStyle="link"
                                                    onClick={() =>
                                                        this.invertSelectedRoutesForStop(stopIndex)
                                                    }
                                                >
                                                    {strings.invertSelection}
                                                </Button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {availableRoutes[stopIndex].map((route, routeIndex) => {
                                            return (
                                                <tr
                                                    key={routeIndex}
                                                    onClick={() =>
                                                        this.toggleRouteSelectionForStop(route, stopIndex)
                                                    }
                                                    className={
                                                        selectedRoutes[stopIndex].filter(
                                                            e => e.id === route.id
                                                        ).length > 0
                                                            ? "bus-map-stop-selected"
                                                            : null
                                                    }
                                                >
                                                    <td>
                                                        {this.getLineParameter(route.lineId, "code")}
                                                    </td>
                                                    <td>
                                                        {this.getNameForOrientation(
                                                            route.lineId,
                                                            route.orientation
                                                        )}
                                                    </td>
                                                    <td>{route.code}</td>
                                                    <td>
                                                        {route.orientation === "G"
                                                            ? strings.go
                                                            : strings.return}
                                                    </td>
                                                    <td>{stopsById[route.stopIds[0]].name}</td>
                                                    <td>
                                                        {
                                                            stopsById[
                                                                route.stopIds[route.stopIds.length - 1]
                                                            ].name
                                                        }
                                                    </td>
                                                    <td></td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </Col>
                        </Row>
                    ))
                    : null}
            </div>
        );
    }

    selectMapPointsTable() {
        var { availableMapPoints, selectedMapPoints } = this.state;

        return (
            <div>
                <Row>
                    <Col>
                        {typeof availableMapPoints !== "undefined" &&
                            availableMapPoints.length !== 0 ? (
                                <Table responsive striped hover>
                                    <thead>
                                        <tr>
                                            <th>{strings.description}</th>
                                            <th className="text-center">
                                                <Button
                                                    bsStyle="link"
                                                    onClick={() => this.selectAllMapPoints()}
                                                >
                                                    {strings.selectAll}
                                                </Button>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {availableMapPoints.map((mapPoint, Index) => (
                                            <tr
                                                key={Index}
                                                onClick={() => this.toggleMapPointSelection(mapPoint)}
                                                className={
                                                    selectedMapPoints.filter(e => e.id === mapPoint.id)
                                                        .length > 0
                                                        ? "bus-map-stop-selected"
                                                        : null
                                                }
                                            >
                                                <td>{mapPoint.name}</td>
                                                <td></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="empty-set">{strings.noMapPointsAvailable}</p>
                            )}
                    </Col>
                </Row>
            </div>
        );
    }

    printSummary() {
        var { selectedStops, selectedRoutes } = this.state;

        return (
            <div>
                <Row>
                    <Col>
                        {selectedStops.map((stop, stopIndex) => (
                            <div key={stopIndex}>
                                <TitleRow
                                    title={`${stop.code} - ${stop.name}`}
                                    showSeparator={false}
                                    showBackground={true}
                                    element="h2"
                                />
                                {selectedRoutes[stopIndex].map((route, routeIndex) => {
                                    return (
                                        <div key={routeIndex}>
                                            <TitleRow
                                                title={`${route.code} - ${this.getNameForOrientation(
                                                    route.lineId,
                                                    route.orientation
                                                )} (${route.orientation === "G"
                                                    ? strings.go
                                                    : strings.return
                                                    })`}
                                                showSeparator={false}
                                                element="h3"
                                            />
                                            <ul className="bus-map-line">
                                                {this.getMapPointsForRouteAfterStop(stop, route)}
                                            </ul>
                                        </div>
                                    );
                                })}
                            </div>
                        ))}
                    </Col>
                </Row>
            </div>
        );
    }

    getMapPointsForRouteAfterStop(stop, route) {
        var { stopsById, mapPointsById, selectedMapPoints } = this.state;

        var currentStopIndex = route.stopIds.indexOf(stop.id);
        var stopsAfterSelected = route.stopIds
            .slice(currentStopIndex + 1)
            .map(stopId => stopsById[stopId])
            .filter(stop => stop.mapPointId > 0);
        // Ir buscar um array com todos os map points de todas as paragens à seguir à actual
        var mapPointsAfterSelected = stopsAfterSelected.map(
            stop => mapPointsById[stop.mapPointId]
        );

        var mapPointsToPrint = mapPointsAfterSelected
            .filter(function (mapPoint) {
                return selectedMapPoints.map(mp => mp.id).includes(mapPoint.id);
            })
            .filter(function (mapPoint) {
                return mapPoint.id !== stop.mapPointId;
            });

        return this.removeDuplicates(
            mapPointsToPrint,
            "id"
        ).map((mapPoint, mapPointIdx) => (
            <li key={mapPointIdx}>{mapPoint.name}</li>
        ));
    }

    changeSort = (column) => {
        var { sortColumn, sortOrder } = this.state;

        if (sortColumn === column) {
            var newSortOrder = sortOrder === "ascending" ? "descending" : "ascending";
            this.setState({
                sortOrder: newSortOrder
            });
        } else {
            this.setState({
                sortColumn: column,
                sortOrder: "ascending"
            });
        }
    }

    sort = (first, second) => {
        const { sortOrder, sortColumn } = this.state;

        var a = (first)[sortColumn];
        var b = (second)[sortColumn];

        if (a === undefined && b === undefined) {
            return 0;
        } else if (a === undefined) {
            if (sortOrder === "ascending") {
                return 1;
            } else {
                return -1;
            }
        } else if (b === undefined) {
            if (sortOrder === "ascending") {
                return -1;
            } else {
                return 1;
            }
        }

        if (sortOrder === "ascending") {
            return typeof a === 'number' ? a - b : a.localeCompare(b);
        }
        return typeof b === 'number' ? b - a : b.localeCompare(a);
    }

    render() {
        var {
            loading,
            dialog,
            errorModal,
            // showExecutingModal,
            currentStep
        } = this.state;
        let contents;

        if (loading && currentStep !== "generate") return <LoadingSpinner />;

        if (currentStep === "stops") {
            contents = (
                <div>
                    <TitleRow title={strings.selectedStops} showSeparator={true}>
                        <Button
                            onClick={() => this.validateStops()}
                            className="pull-right"
                            disabled={this.state.selectedStops.length === 0}
                        >
                            {strings.selectRoutes}
                        </Button>
                        <Button
                            onClick={() => this.selectAllStops()}
                            className="pull-right"
                        >
                            {strings.selectAllRoutesForAllStops}
                        </Button>
                    </TitleRow>
                    {this.stopSelectionFilters()}
                    <Row className="no-padding">
                        {this.selectStopsTable()}
                        {this.listSelectedStops()}
                    </Row>
                </div>
            );
        } else if (currentStep === "routes") {
            contents = (
                <div>
                    <TitleRow title={strings.selectRoutes} showSeparator={true}>
                        <Button
                            onClick={() => this.validateRoutes()}
                            className="pull-right"
                            disabled={this.state.selectedRoutes.flat().length === 0}
                        >
                            {strings.selectMapPoints}
                        </Button>
                        <Button
                            onClick={() => this.selectAllRoutesForAllStops()}
                            className="pull-right"
                        >
                            {strings.selectAllRoutesForAllStops}
                        </Button>
                        <Button onClick={() => this.selectStops()} className="pull-right">
                            {strings.back}
                        </Button>
                    </TitleRow>
                    {this.selectRoutesTable()}
                </div>
            );
        } else if (currentStep === "mapPoints") {
            contents = (
                <div>
                    <TitleRow title={strings.selectMapPoints} showSeparator={true}>
                        <Button
                            onClick={() => this.validateMapPoints()}
                            className="pull-right"
                            disabled={this.state.selectedMapPoints.length === 0}
                        >
                            {strings.showSummary}
                        </Button>
                        <Button onClick={() => this.selectRoutes()} className="pull-right">
                            {strings.back}
                        </Button>
                    </TitleRow>
                    {this.selectMapPointsTable()}
                </div>
            );
        } else if (currentStep === "summary") {
            contents = (
                <div>
                    <TitleRow title={strings.summary} showSeparator={true}>
                        <Button
                            onClick={() => this.generateBusMaps()}
                            className="pull-right"
                        >
                            {strings.generateBusMaps}
                        </Button>
                        <Button
                            onClick={() => this.selectMapPoints()}
                            className="pull-right"
                        >
                            {strings.back}
                        </Button>
                    </TitleRow>
                    {this.printSummary()}
                </div>
            );
        } else if (currentStep === "generate") {
            contents = (
                <div>
                    <TitleRow title={strings.generatingBusMaps} showSeparator={true}>
                        <Button
                            onClick={() => this.generateBusMaps()}
                            className="pull-right"
                            disabled={this.state.loading}
                        >
                            Gerar de Novo
            </Button>
                    </TitleRow>
                    {this.state.loading ? (
                        <LoadingSpinner />
                    ) : typeof this.state.generatedFiles !== "undefined" &&
                        this.state.generatedFiles.length !== 0 ? (
                                <ul>
                                    {this.state.generatedFiles.map((file, fileIndex) => (
                                        <li key={fileIndex}>
                                            <a href="">{file}</a>
                                        </li>
                                    ))}
                                </ul>
                            ) : null}
                </div>
            );
        } else {
            return null;
        }

        return (
            <div className="container-fluid busmap">
                {contents}
                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExit(a, b)}
                />
                <HandleMessage
                    show={errorModal.show}
                    title={errorModal.title}
                    message={errorModal.message}
                    style={errorModal.style}
                    icon={errorModal.icon}
                    extraButton={errorModal.extraButton}
                    onHide={this.clearError}
                />
                <HandleMessage
                    show={this.state.showExecutingModal}
                    title={strings.generatingBusMaps}
                    message={<LoadingSpinner />}
                    icon="transfer"
                    style={`primary`}
                    onHide={this.clearError}
                    small
                    noButtons
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/busmap/NewBusMap.js